// src/Redux/Support/contactSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../UtilsRedux/axiosWithAuth'; // same instance you use elsewhere
import { API_ROUTES } from '../../Constants/apiRoutes';
import { showFeedback } from '../../UI/uiFeedbackSlice';

export const submitContact = createAsyncThunk(
  'contact/submit',
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await axios.post(API_ROUTES.SUPPORT_CONTACT, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      // ✅ success popup
      dispatch(
        showFeedback({
          type: 'success',
          title: 'Message sent',
          message: res.data?.message || 'Thanks! We’ll get back to you shortly.',
        })
      );

      return res.data; // { success:true, message:"Message sent" }
    } catch (err) {
      const message =
        err?.response?.data?.message || 'Failed to send message';

      // ❌ error popup
      dispatch(
        showFeedback({
          type: 'error',
          title: 'Could not send message',
          message,
        })
      );

      return rejectWithValue(message);
    }
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    status: 'idle',   // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    lastMessage: null,
  },
  reducers: {
    resetContactState: (state) => {
      state.status = 'idle';
      state.error = null;
      state.lastMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContact.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(submitContact.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.lastMessage = action.payload?.message || 'Message sent';
      })
      .addCase(submitContact.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = contactSlice.actions;
export default contactSlice.reducer;
